import App from './components/App';
import './styles/prelude.css';
import './styles/global.scss';

export default App;